import { gql } from '@apollo/client'

/* coinList no longer exists in backend schema */
export const GET_COINS_LIST = gql`
  query coinListStub {
    __typename
  }
`
